(() => {
  const form = document.getElementById('SteakSelectionForm');
  if (!form || form.dataset.bound) return;
  form.dataset.bound = 'true';
  const giftChoice = document.getElementById('SteakGiftChoice');
  const preview = document.getElementById('SteakSelectionPreview');
  const error = document.getElementById('SteakSelectionError');
  const button = form.querySelector('button[type="submit"]');
  const existingCustomer = form.dataset.existingCustomer === 'true';
  if (existingCustomer || new URLSearchParams(window.location.search).get('bonus') === 'ohne') giftChoice.checked = false;
  if (existingCustomer) giftChoice.disabled = true;
  const money = (cents) => new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(cents / 100);
  preview.querySelectorAll('[data-close-preview]').forEach(button => button.addEventListener('click', () => preview.close()));
  document.querySelectorAll('a[href="#steak-absicherung"]').forEach(link => link.addEventListener('click', () => { document.getElementById('steak-absicherung').open = true; }));
  document.querySelectorAll('a[href="#steak-bonusbedingungen"]').forEach(link => link.addEventListener('click', () => { document.getElementById('steak-bonusbedingungen').open = true; }));
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    error.hidden = true;
    const withGift = giftChoice.checked && !giftChoice.disabled && !existingCustomer;
    if (withGift && (form.dataset.giftReady !== 'true' || !form.dataset.giftId || Number(form.dataset.total) < 14900)) {
      error.textContent = 'Der Neukundenbonus ist für diese Auswahl gerade nicht verfügbar. Bitte bestelle ohne Geschenk oder lade die Seite neu.';
      error.hidden = false;
      return;
    }
    if (form.dataset.ordering !== 'true') {
      document.getElementById('SteakGiftPreview').textContent = withGift ? 'Neukundenbonus: 1 × 500 g Bio-Rinderhack · ' + money(Number(form.dataset.giftPrice)) + ' − ' + money(Number(form.dataset.giftPrice)) + ' = 0,00 €' : 'Ohne Neukundenbonus.';
      preview.showModal();
      return;
    }
    // A configured, activated Shopify rule is required before enabling this branch.
    if (withGift && !form.dataset.discountCode) {
      error.textContent = 'Der Neukundenbonus ist gerade nicht verfügbar. Bitte bestelle ohne Geschenk oder versuche es später erneut.';
      error.hidden = false;
      return;
    }
    button.disabled = true;
    let addAttempted = false;
    let bonusValidationAttempted = false;
    try {
      if (!window.jaesaCartNetwork) throw new Error('Cart initialization unavailable');
      await window.jaesaCartNetwork.waitForIdle();
      const cartResponse = await fetch(form.dataset.cartUrl + '.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!cartResponse.ok) throw new Error('Cart unavailable');
      const cart = await cartResponse.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
      if (cart.items.some(item => item.properties && item.properties._jaesa_selection === 'steak_202609')) {
        error.textContent = 'Deine Auswahl ist bereits ganz oder teilweise im Warenkorb. Bitte prüfe sie dort, bevor du weitere Stücke hinzufügst. ';
        const cartLink = document.createElement('a');
        cartLink.href = form.dataset.cartUrl;
        cartLink.textContent = 'Warenkorb ansehen →';
        error.append(cartLink);
        error.hidden = false;
        button.textContent = 'Auswahl bereits im Warenkorb';
        return;
      }
      const giftAlreadyPresent = cart.items.some(item => String(item.variant_id) === form.dataset.giftId && item.quantity > 0 && !item.selling_plan_allocation);
      const body = new FormData(form);
      // Carry gift intent on the selection, including when a 500 g pack was already in the cart.
      for (let index = 0; index < 3; index++) {
        body.append('items[' + index + '][properties][_jaesa_bonus_requested]', withGift ? 'true' : 'false');
      }
      if (withGift && !giftAlreadyPresent) {
        body.append('items[3][id]', form.dataset.giftId);
        body.append('items[3][quantity]', '1');
        body.append('items[3][properties][_jaesa_selection]', 'steak_202609');
        body.append('items[3][properties][_jaesa_gift]', 'steak500');
      }
      addAttempted = true;
      const response = await fetch(form.dataset.addUrl, {method: 'POST', body, headers: {'Accept': 'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Die Auswahl konnte nicht vollständig hinzugefügt werden.');
      await window.jaesaCartNetwork.waitForIdle();
      if (withGift) {
        bonusValidationAttempted = true;
        const discountResponse = await fetch(form.dataset.cartUrl + '/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({discount: form.dataset.discountCode})
        });
        const discounted = await discountResponse.json();
        if (!discountResponse.ok || !Array.isArray(discounted.items)) throw new Error('Bonus could not be checked');
        const giftIsFree = discounted.discount_codes?.some(discount => discount.code.toUpperCase() === form.dataset.discountCode.toUpperCase() && discount.applicable === true)
          && discounted.items.some(item => String(item.variant_id) === form.dataset.giftId && item.discounts?.some(discount => discount.title.toUpperCase() === form.dataset.discountCode.toUpperCase() && Number(discount.amount) >= Number(item.original_price ?? item.price)));
        if (!giftIsFree) throw new Error('Bonus not applied');
      }
      await window.jaesaCartNetwork.waitForIdle();
      const finalResponse = await fetch(form.dataset.cartUrl + '.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      const finalCart = await finalResponse.json();
      if (!finalResponse.ok || !Array.isArray(finalCart.items) || !finalCart.items.some(item => item.properties?._jaesa_selection === 'steak_202609')) throw new Error('Selection not retained');
      if (withGift && !finalCart.discount_codes?.some(discount => discount.code.toUpperCase() === form.dataset.discountCode.toUpperCase() && discount.applicable)) throw new Error('Bonus not retained');
      window.location.assign(form.dataset.cartUrl);
    } catch (failure) {
      if (!addAttempted) {
        error.textContent = 'Wir konnten deinen Warenkorb gerade nicht prüfen. Es wurde nichts hinzugefügt. Bitte versuche es erneut.';
        error.hidden = false;
        button.disabled = false;
        return;
      }
      error.textContent = bonusValidationAttempted
        ? 'Die Auswahl wurde hinzugefügt, aber der Gratis-Bonus konnte nicht bestätigt werden. Bitte prüfe das Hack im Warenkorb, bevor du zur Kasse gehst. '
        : 'Die Rückmeldung ist unklar. Bitte prüfe deinen Warenkorb: Die Auswahl könnte bereits enthalten sein. ';
      const cartLink = document.createElement('a');
      cartLink.href = form.dataset.cartUrl;
      cartLink.textContent = 'Warenkorb prüfen →';
      error.append(cartLink);
      error.hidden = false;
      button.textContent = 'Bitte zuerst den Warenkorb prüfen';
    }
  });
  button.disabled = form.dataset.ready !== 'true';
})();
